export default "__VITE_ASSET__Clfl9KMW__"